module.exports = __webpack_public_path__ + "img/03logo-rin2022.cc05b317.png";